import { connect } from 'react-redux';
import MainPage from './MainPage';


const MainPageComponent = connect(
    function mapStateToProps(state) {
        return {
            isNavExtended: state.isNavExtended
        };
    }
)(MainPage);

export default MainPageComponent;
